const { default: FlipButton } = require('./FlipButton');

export default FlipButton;
